/* eslint-disable object-shorthand */

import { mapActions, mapGetters, mapState } from 'vuex';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import { formMixin, validators } from '@/components/forms/mixin';
import { FORM_TYPE_IDV } from '@/constants';

export default {
  components: {
    contentHeader,
  },
  mixins: [
    formMixin,
  ],
  validations: {
    fields: {
      address: validators.required,
      city: validators.required,
      zipCode: validators.validateUSZipCode('country'),
      country: validators.required,
    },
  },
  watch: {
    userData(value) {
      if (value) {
        this.assignFields(value);
      }
    },
    'fields.address'(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.city'(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.zipCode'(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.dataUpdated = true;
      }
    },
    'fields.country'(newValue, oldValue) {
      if (oldValue && newValue.value !== oldValue.value) {
        this.dataUpdated = true;
      }
    },
  },
  data() {
    return {
      dataUpdated: false,
      countries: [],
      fields: {
        country: '',
        address: '',
        city: '',
        zipCode: '',
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('user', ['userData']),
    isNotUnitedStates() {
      return this.fields.country &&
        this.fields.country.value &&
        this.fields.country.value !== 'US';
    },
    isSubmitButtonDisabled() {
      return !this.dataUpdated || this.invalidOrDisabled;
    },
  },
  methods: {
    ...mapActions('notifications', ['setSuccessSideNotificationWithTimeoutCallback']),
    ...mapActions('user', ['verifyID', 'getAccountDetail', 'getVerifyID']),
    onSubmit() {
      if (this.formIsValid() && this.formDisable()) {
        const payload = {
          address1: this.fields.address,
          city: this.fields.city,
          postalCode: this.fields.zipCode,
          countryID: this.fields.country.value,
          formType: FORM_TYPE_IDV.CHANGE_ADDRESS,
        };
        if (!this.isNotUnitedStates) {
          payload.nscbStatus = -1;
        }
        this.verifyID(payload)
        .then((data) => {
          if (this.isNotUnitedStates) {
            window.location.href = data;
            return Promise.reject('');
          }
          this.dataUpdated = false;
          return this.setSuccessSideNotificationWithTimeoutCallback({
            text: 'Account Address Updated.',
            callback: () => this.$router.go(-1),
          });
        })
        .then(this.formEnable)
        .then(this.getAccountDetail)
        .catch((e) => {
          this.formHandleErrors(e);
        });
      }
    },
    assignFields(value) {
      this.fields.address = value.address;
      this.fields.city = value.city;
      this.fields.zipCode = value.postalCode;

      if (value.countryCode) {
        this.fields.country = this.countries.find(i => i.value === value.countryCode) || '';
      }
    },
  },
  created() {
    this.getVerifyID().then((response) => {
      const data = response.data;
      this.countries = data.countryList.map(el => ({
        required: el.validatePostalCode,
        label: el.countryName,
        value: el.countryCode,
      }));

      this.fields.country = this.countries.find(i => i.value === data.countryID) || '';
      if (this.userData) this.assignFields(this.userData);
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-details/update/account-address-update.js